/** Первая буква — заглавная (русские месяцы/дни недели из локали идут строчными). */
export const capitalize = (s: string): string => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
